import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import './FailurePage.css';

const FailurePage = props => (
  <div className="failure-center">
    {props.errorState === 'NOT_FOUND' ?
      <h2 className="failureErrorTitle">
        <FormattedMessage
          id="invalidDevice"
          defaultMessage="This does not appear to be a valid device."
        />
      </h2>
        :
      <h2 className="failureErrorTitle">
        <FormattedMessage
          id="genericPageError"
          defaultMessage="Oops! We encountered a problem."
        />
        <FormattedMessage
          id="genericPageErrorAction"
          defaultMessage="Please go back to the Device List and try again."
        />
      </h2>
    }
    <div className="failureAction">
      <button
        className="defaultButton"
        onClick={() => {
          props.clearError();
        }}
      >
        <FormattedMessage
          id="goBack"
          defaultMessage="Back to Device List"
        />
      </button>
    </div>
  </div>
);

FailurePage.propTypes = {
  errorState: PT.string,
  clearError: PT.func
};

export default FailurePage;



// WEBPACK FOOTER //
// ./src/components/FailurePage/FailurePage.js